import type { ScaleBand } from 'd3-scale';
import { useTheme } from '@simplywallst/ui-core';
import { Postfix, Label } from './styled';

interface Props {
  yScale: ScaleBand<string>;
  series: string[];
  y: number;
}

const YAxis = ({ yScale, series, y }: Props) => {
  const theme = useTheme();
  return (
    <svg y={y} width="100%" height={yScale.range()[1]}>
      {series.map((n, i) => {
        return (
          <g key={`insider-trading-yaxis-${n}`}>
            <Label
              y={i * yScale.bandwidth() + theme.x1spacePx}
              dominantBaseline="hanging"
              textAnchor="start"
            >
              {n}
            </Label>
            <Postfix
              y={i * yScale.bandwidth() + theme.x4spacePx}
              dominantBaseline="hanging"
              textAnchor="start"
            >
              months
            </Postfix>
            <rect
              x="0"
              y={i * yScale.bandwidth()}
              width="100%"
              height="1"
              fill={theme.color.white}
              fillOpacity={0.1}
            />
          </g>
        );
      })}
    </svg>
  );
};

export default YAxis;
